import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { HubService } from './hub.service';
import { isPlatformBrowser } from "@angular/common";
import { Guid, Utility } from '../core/common'
import { BehaviorSubject, ReplaySubject, Subject } from "rxjs";
import { Constants, OrderType } from "../model/common.model";
import * as moment from "moment-timezone";
import { MenuItem } from "primeng/api";

const clientIdKey = 'UserService_clientId';

export interface VKeyboardOptions {
  mode?: 'decimal' | 'default',
  showOnFocus?: boolean;
}

export interface VKeyboardEvent {
  element: HTMLInputElement | HTMLTextAreaElement,
  options: VKeyboardOptions
}

@Injectable({
  providedIn: 'root'
})
export class AppService {

  clientId: string;
  isBrowser: boolean = false;
  static britEatCompanyInfo = {
    companyName: 'BritEat LTD',
    fullAddress: 'Unit 9/10. Service bay the stow, Harlow, CM17 9QS, United Kingdom',
    postCode: 'CM17 9QS',
    website: 'https://briteat.co.uk',
    supportEmail: 'support@briteat.co.uk',
    supportPhone: '+44 7932 973156'
  }

  breadcrumb$ = new BehaviorSubject<MenuItem[] | undefined>(undefined);

  activeBusiness: any;
  activeBusiness$ = new ReplaySubject<any>(1);
  // The active brand HQ when the current domain resolves to an HQ (parent
  // brand) rather than a single business.
  activeHq: any;
  activeHq$ = new ReplaySubject<any>(1);
  operatingHours: { [orderType: string]: { state: string, from: string, fromDate?: Date } };
  public pos = false;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private hubService: HubService) {

    // router.events.pipe(
    //   filter(event => event instanceof NavigationEnd),
    //   map(() => route),
    //   map(r => r.firstChild),
    //   switchMap(r => r.data)
    // ).subscribe(data => {
    //   debugger;
    // });


    this.isBrowser = isPlatformBrowser(this.platformId);

    this.setClientId();

    this.activeHq$.subscribe(hq => this.activeHq = hq);

    this.activeBusiness$.subscribe(business => {
      this.activeBusiness = business;
      if (!business) return;


      var orderTypes = [...new Set<OrderType>(
        business.OrderTypes || business.OperatingHours?.map(_ => _.OrderType) || Constants.OrderTypes || []
      )];

      this.operatingHours = Object.assign({}, ...orderTypes?.map(type => {
        var closed = business?.StopOpertingUntil ? new Date(business?.StopOpertingUntil) : null;
        var times = business?.OperatingHours?.filter(_ => _.OrderType == type && _.Days?.includes(Constants.WeekDays[new Date().getDay()]));
        var open = times?.some(_ => this.hasTimePassed(_.StartTime) && (_.StartTime > _.EndTime || !this.hasTimePassed(_.EndTime)));
        var from = open ? null : times?.find(_ => _.StartTime > _.EndTime || !this.hasTimePassed(_.EndTime))?.StartTime;
        var fromDate = !from ? null : this.getDateByTime(from)
        if (closed > new Date())
          return {
            [type]: {
              state: 'closed',
              from: from && this.hasTimePassed(from, closed) ? from : Utility.dateDiff(closed),
              fromDate
            }
          };
        return { [type]: { state: open ? 'open' : 'closed', from, fromDate } };
      }));

    });
  }

  getDateByTime(time: string, base?: Date) {
    var target = moment.tz(base || new Date(), this.activeBusiness.TimeZone);
    target.set({ hour: parseInt(time.split(':')[0]), minute: parseInt(time.split(':')[1]), second: parseInt(time.split(':')[2]) });
    return target.toDate();
  }
  hasTimePassed(time: string, base?: Date) {
    base = base || new Date();
    return this.getDateByTime(time, base) < base;
  }


  private setClientId() {
    if (typeof localStorage === 'undefined') return;

    this.clientId = localStorage.getItem(clientIdKey);
    if (!this.clientId) {
      this.clientId = Guid.newGuid();
      localStorage.setItem(clientIdKey, this.clientId);
    }
    this.hubService.join(this.clientId);
  }

  ngOnDestroy() {
    this.hubService.leave(this.clientId);
  }

  downloadBlob(data: ArrayBuffer, type: string, name: string) {
    let blob = new Blob([data], { type: type });
    let url = window.URL.createObjectURL(blob);

    let a = document.createElement('a');
    a.href = url;
    a.download = name;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

  }

  openBlob(data: ArrayBuffer, type: string, features: string = 'width=600,height=800') {
    let blob = new Blob([data], { type: type });
    let url = window.URL.createObjectURL(blob);
    window.open(url, '_blank', features);
  }

  // virtual keyboard implementation
  private keyboardSubject = new Subject<VKeyboardEvent|undefined>();
  keyboard$ = this.keyboardSubject.asObservable();
  keyboardValue$ = new BehaviorSubject<string>('');

  showKeyboard(event: VKeyboardEvent) {
    this.keyboardSubject.next(event);
  }

  hideKeyboard() {
    this.keyboardSubject.next(undefined);
  }


}